const isMD5 = (text) => {
    const md5Regex = /^[a-fA-F0-9]{32}$/;
    return md5Regex.test(text);
};

export { isMD5 };
